/**
 * Generated runtime TestId mirror for frontend/src/pages/RequestInspectorDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RequestInspectorDetailTestIds = {
  btnDownloadTrace: "btn-download-trace",
  cardTitleDetail: "card-title-detail",
  cardTitleRequests: "card-title-requests",
  colDuration: "col-duration",
  colMethod: "col-method",
  colSqlCount: "col-sql-count",
  colSqlTime: "col-sql-time",
  colStatus: "col-status",
  colUrl: "col-url",
  requestInspectorDetailPage: "request-inspector-detail-page",
  requestsTable: "requests-table",
  requestRow: (span_spanId: string) => `request-row-${span_spanId}`,
  requestRowPrefix: () => "request-row-" as TestIdPrefix
} as const;
